
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import { hifenUrl } from '../../../utils/hifenUrl';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { formatCaracteristicas, formatSelects, formatSelectsTransacao, hexToRgba, isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import {
    getImoveisListCaracteristicasStorageKey,
    getImoveisListCategoryStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../../utils/storage';
import { appendCodsiteQuery } from '../../../utils/url';
import { buscaCidadeFixaEstrita } from '../../../utils/condominiosBusca';
import { genMetaEventId, trackMetaEvent } from '../../../utils/metaPixel';
import { getHeroVideoPoster, useHeroVideoReady } from '../../../utils/heroVideo';
import { useCidadeFixaBusca } from '../../../utils/cidadeFixaBusca';
import { useAuth, useRegiaoHref } from '../../context/Info';
import { useCidadesMulti } from '../../shared/city-multi/useCidadesMulti';
import DrawerComponent from '../../drawer/DrawerComponent';
import CardsBusca from '../../shared/cards-busca/CardsBusca';
// framer-motion REAL (não o lightMotion estático): fade-in no topo/busca pra esconder a
// renderização feia dos selects (ssr:false) sobre a caixa colorida. Custo aceito (Daniel 24/06).
import { motion } from 'framer-motion';
import { customSelectPropertiesStyles } from './WelcomePieces.mocks';
import styles from './WelcomePieces2.module.css';
import { usePreviaBuilder } from '../../../lib/previaBuilder';

// Sites que mostram o H1 do banner também no celular (pedido do cliente).
const HERO_TITULO_NO_CELULAR = new Set<number>([2639]);

const Select = dynamic(() => import('react-select'), { ssr: false });

// Sites que mostram o campo de Código direto na barra, sem precisar abrir a busca avançada:
// 2073 (já era) e 2023 (saldanhaimoveisfloripa — pediu a barra no modelo do 2420 COM o código).
const CODIGO_NA_BARRA_SITES = [2073, 2023];

interface IWelcomePieces2 {
  personaSrc: any;
  allCities: Array<{ label: string; value: string; id_estado: any }>;
  allTypes: any;
  allTransacao: Array<{ label: string; value: string }>;
  allCompany: Array<{ label: string; value: string }>;
  site: any;
  urlBanner: string;
  companyInputActual: any;
  setCompanyInputActual: any;
  setActiveDrawer: any;
  activeDrawer: any;
  origin?: any;
  codsite?: any;
  favorito: Array<number>;
  valores?: any;
  codsite2?: any;
  isMobile1?: Boolean;
  props: any;
  setBuscaAvancada: any;
  buscaAvancada: any;
  allCards?: any;
}

const WelcomePieces2: React.FC<IWelcomePieces2> = ({
  personaSrc,
  allCities,
  allTypes,
  allCompany,
  allTransacao,
  site,
  urlBanner,
  companyInputActual,
  setCompanyInputActual,
  setActiveDrawer,
  activeDrawer,
  origin,
  codsite,
  favorito,
  valores,
  codsite2,
  isMobile1,
  buscaAvancada,
  setBuscaAvancada,
  props,
  allCards
}) => {
    const { videoParado } = usePreviaBuilder(); // prévia dos cards do CRM: vídeo parado na capa
  // Hero: pôster (leve) é o LCP; o vídeo (pesado) carrega só depois do LCP. Só p/ vídeos
  // default (que têm pôster pronto); custom segue eager (sem regressão de flash).
  const heroPoster = getHeroVideoPoster(site?.url_video);
  const heroVideoReady = useHeroVideoReady();
  const {
      listCategory,
      setListCategory,
      listEstados,
      setListEstados,
      listCaracteristicas,
      setListCaracteristicas,
      listDatas,
      setListDatas
  } = useAuth();
  // cs2639 (23/09): no celular o modelo esconde o H1 (.textContent display:none); este site quer o H1
  // visível entre o topo fixo e o seletor "Venda". Só abaixo de 768px — desktop e demais sites iguais.
  const heroTituloNoCelular = HERO_TITULO_NO_CELULAR.has(Number(site?.id));
  const isSite2507 = Number(site?.id) === 2507;
  const isSite2587 = Number(site?.id) === 2587;
  // cs2262 (Hause Private Brokers): Condominio ao lado do Bairro na busca simples, fora da avancada
  const isSite2262 = Number(site?.id) === 2262;
  // cs1630 (Prospect): Empreendimentos tambem na busca simples (segue na avancada), com o rotulo "Empreendimentos"
  const isSite1630 = Number(site?.id) === 1630;
  const showHomeCategoria = Boolean(site?.categoria_home) && !isSite2507;
  const showHomeCaracteristicas = Boolean(site?.caracteristicas_home) && !isSite2507;
  const showHomeDormitorios = true;

  const [showAdvanced, setShowAdvanced] = useState<boolean>(site?.id == 2379 ? buscaAvancada : false);
  const [transacaoActual, setTransacaoActual] = useState<any>(allTransacao[0]);

  const getBoundsByTransaction = useCallback((transactionValue?: string) => {
      const normalizedTransaction = String(
        transactionValue || allTransacao[0]?.value || ''
      ).toLowerCase();

      if (normalizedTransaction === 'aluguel') {
          return valores?.precos_locacao?.[0];
      }
      if (normalizedTransaction === 'venda') {
          return valores?.precos_venda?.[0];
      }
      if (normalizedTransaction === 'temporada' && valores?.precos_locacao?.[0]) {
          return valores?.precos_locacao?.[0];
      }

      if (valores?.precos_venda?.[0]?.max > 0) {
          return valores?.precos_venda?.[0];
      }

      return valores?.precos_locacao?.[0];
  }, [allTransacao, valores]);
  const getFiltersPricess = getBoundsByTransaction(transacaoActual?.value);
  const onlyDigits = (str: string) => str.replace(/\D/g, ''); // remove tudo que não é número

  const [precoMin, setPrecoMin] = useState<number>(Number(getFiltersPricess?.min) || 0);
  const [precoMax, setPrecoMax] = useState<number>(Number(getFiltersPricess?.max) || 0);

  // MULTI-FILIAIS: preserva a filial ativa nos links de busca do hero.
  const withRegiao = useRegiaoHref();

  function renderPath() {
    const treatString = (str: string, def = '-') =>
      str ? hifenUrl(String(str), site?.id).replaceAll(' ', '%20') : def;

    const transacao = transacaoActual?.value?.toLowerCase() || allTransacao[0]?.value?.toLowerCase() || 'venda';
    // Cidade fixa estrita: com CÓDIGO digitado, cidade e bairro saem da busca —
    // senão a cidade fixa esconderia imóvel de outra cidade (utils/condominiosBusca).
    const codigoVenceCidade = buscaCidadeFixaEstrita(site?.id) && !!codeActual;
    const cidade = codigoVenceCidade ? '-' : treatString(citiesActual?.label);
    const bairro = codigoVenceCidade ? '-' : treatString(urlDistrict);
    const company = treatString(companyActual?.label);
    const tipo = treatString(urlTipo);
    const codigo = codeActual ? `/${codeActual.replaceAll('%20', '')}` : '';

    const params = new URLSearchParams();
    const isEmptySite2551Search =
      Number(site?.id) === 2551 &&
      !codeActual &&
      !citiesActual?.label &&
      !urlDistrict &&
      !companyActual?.label &&
      !urlTipo &&
      !buscaAvan;

    if (buscaAvan || site?.id == 2177) {
      if (estadoActual?.value) params.set('id_estado', String(estadoActual.value));
      params.set('min', String(precoMin || 0));
      params.set('max', String(precoMax || 0));
      if (urlDatas) params.set('data_entrega', String(urlDatas));
      if (showHomeCategoria && categoryActual?.value) params.set('categoria', String(categoryActual.value));
      if (showHomeDormitorios) params.set('dormitorios', String(Number(dormitoriosActual?.value ?? String(dormitoriosActual || '').replace(/\D/g, '')) || 0));
      params.set('banheiros', String(banheirosActual?.value ?? banheirosActual ?? 0));
      params.set('suites', String(suitesActual?.value ?? suitesActual ?? 0));
      params.set('vagas', String(vagasActual?.value ?? vagasActual ?? 0));
      if (showHomeCaracteristicas && urlCaract) params.set('id_caracteristica', String(urlCaract));
    }
    if (isEmptySite2551Search) {
      params.set('ordem', 'desc-inclusao');
    }
    // MULTI-FILIAIS: 2+ cidades marcadas viram `?cidades=<ids>`.
    if (cidadesMulti.queryCidades) params.set('cidades', cidadesMulti.queryCidades);

    let newPath = `/imoveis/${transacao}/${cidade}/${bairro}/${company}/${tipo}${codigo}`;
    if (params.toString()) {
      newPath = `${newPath}?${params.toString()}`;
    }

    newPath = appendCodsiteQuery(newPath, codsite2, origin);
    newPath = newPath.replaceAll(' ', '-');
    newPath = removerAcentos(newPath).toLowerCase();

    // MULTI-FILIAIS: a busca leva a filial ativa para a listagem (?regiao=).
    return withRegiao(newPath);
  }

  // Meta Pixel: evento Search no clique de "Encontrar imóvel"/"Filtrar" (não trava a
  // navegação; alimenta a dedup do Search CAPI da listagem via 'meta:searchEventId').
  const fireMetaSearch = () => {
    const transacaoNome = transacaoActual?.label || transacaoActual?.value || allTransacao[0]?.value || '';
    const tipoNome = (typesActual || []).map((t: any) => t?.label).filter(Boolean).join(', ');
    const cidadeNome = citiesActual?.label || '';
    const bairroNome = (districtActual || []).map((d: any) => d?.label).filter(Boolean).join(', ');
    const searchString = [transacaoNome, tipoNome, cidadeNome, bairroNome].filter(Boolean).join(' | ');
    const eventId = genMetaEventId();
    try { sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() })); } catch { /* sessionStorage indisponível — Search sai sem dedup c/ CAPI */ }
    trackMetaEvent(site, 'Search', {
      search_string: searchString,
      transaction_type: transacaoNome,
      property_type: tipoNome,
      city: cidadeNome,
      neighborhood: bairroNome,
    }, { eventId });
  };

  const clearFilters = () => {
    const defaultBounds = getBoundsByTransaction(allTransacao[0]?.value);

    setCitiesActual(null)
    setTransacaoActual(allTransacao[0])
    setPrecoMin(Number(defaultBounds?.min) || 0)
    setPrecoMax(Number(defaultBounds?.max) || 0)
    setDistrictActual([])
    setTypesActual([])
    setCaractActual([])
    setDataEntregaActual([])
    setCategoryActual([])
    setEstadoActual([])
    setDormitoriosAtual('')
    setBanheirosAtual('')
    setSuitesAtual('')
    setVagasAtual('')
    setCodeActual('')
    setCompanyActual(null)
  };

      const [allDistrict, setAllDistrict] = useState([]);
      const cidadesBaseBusca = useMemo(
        () => (site?.id == 2177 ? allCities.filter((city: any) => city?.id_estado == 24) : allCities),
        [allCities, site?.id]
      );
      const [allCitiesAux, setAllCitiesAux] = useState(cidadesBaseBusca);
      // MULTI-FILIAIS: acompanha a troca de filial (ver welcome/WelcomePieces).
      useEffect(() => {
        setAllCitiesAux(cidadesBaseBusca);
      }, [cidadesBaseBusca]);
      const [citiesActual, setCitiesActual] = useState<any>(null);
      const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
      const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
      const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
      const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
      const [categoryActual, setCategoryActual] = useState<any>([]);
      const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2177 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
      const [urlTipo, setUrlTipo] = useState<string>("");
      const [urlCaract, setUrlCaract] = useState<string>("");
      const [urlDatas, setUrlDatas] = useState<string>("");
      const [urlDistrict, setUrlDistrict] = useState<string>("");
      const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
      const [banheirosActual, setBanheirosAtual] = useState<any>();
      const [suitesActual, setSuitesAtual] = useState<any>();
      const [vagasActual, setVagasAtual] = useState<any>();
      const [codeActual, setCodeActual] = useState('');
      const [companyActual, setCompanyActual] = useState<any>(null);
      const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
      const cor_fundo = site?.cor12;
      const cor_bordas = isColorLight(site?.cor12) ? site?.cor11 : site?.cor13;
      const baseBg = cor_fundo || '#000000';
      const baseBorder = cor_bordas || '#ffffff';
      const codeInputVars: React.CSSProperties = {
        ['--code-input-bg' as any]: hexToRgba(baseBg, 0.6),
        ['--code-input-border' as any]: hexToRgba(baseBorder, 0.1),
        ['--code-input-text' as any]: isColorLight(baseBg) ? baseBorder : '#FFFFFF',
        ['--code-input-placeholder' as any]: isColorLight(baseBg)
          ? hexToRgba(baseBorder, 0.7)
          : 'rgba(255,255,255,0.8)',
      };
      const storageHost = site?.site || (typeof window !== 'undefined' ? window.location.host : '');
      const storageCodsite = codsite || site?.id || 0;
      const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
      const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
      const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
      const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);

      const readLocalArray = (key: string) => {
          if (typeof window === 'undefined') return [];
          const value = readJsonStorageValue<any>(window.localStorage, key, []);
          return Array.isArray(value) ? value : [];
      };

      const withReadyDeliveryOption = (value: any) => {
          const options = Array.isArray(value) ? value.filter(Boolean) : [];
          const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
          const remaining = options.filter(
              (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
          );

          return [readyItem, ...remaining];
      };

      const onChangeCity = useCallback(async (txt: any) => {
          if (!txt) {
              setCitiesActual(null);
              setDistrictActual([]);
              setAllDistrict([]);
              return;
          }
          if (citiesActual?.value === txt?.value) return;
          setCitiesActual(txt);
          const infoDistrict = await district(txt.value, origin, codsite);
          setAllDistrict(formatSelects(infoDistrict?.bairros));
          setDistrictActual([]);
      }, [citiesActual?.value, codsite, origin]);
      // MULTI-FILIAIS: select de cidade multi no modo popup (ver useCidadesMulti).
      const cidadesMulti = useCidadesMulti(onChangeCity, allCitiesAux);
      // Cidade fixa na busca (CRM → Comportamento): abre o formulário já com a cidade do tenant.
      useCidadeFixaBusca(site?.cidade_busca, allCitiesAux, Boolean(citiesActual), onChangeCity);
      const onChangeDistrict = (txt: any) => {
          setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
          setDistrictActual(txt);
      };
      const onChangeCompany = (txt: any) => {
          setCompanyActual(txt);
      };
      const onChangeTypes = (txt: any) => {
          setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
          setTypesActual(txt);
      };
      const onChangeCategory = (txt: any) => {
          if(categoryActual == txt)
              setCategoryActual([]);
          else
          setCategoryActual(txt);

          setBuscaAvan(true);
      };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        const nextBounds = getBoundsByTransaction(txt?.value);

        setTransacaoActual(txt);
        setPrecoMin(Number(nextBounds?.min) || 0)
        setPrecoMax(Number(nextBounds?.max) || 0)
        setBuscaAvan(true);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = useCallback(async () => {
        if(listEstados === 0 && site?.id == 2177){
            const getCondo: any = readLocalArray(listStatesStorageKey);

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem(listStatesStorageKey, JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory === 0 && showHomeCategoria){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas === 0 && showHomeCaracteristicas){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(withReadyDeliveryOption(getCondo));
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    void newItem;
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }, [codsite, listCaracteristicas, listCaracteristicasStorageKey, listCategory, listCategoryStorageKey, listDatas, listDatasStorageKey, listEstados, listStatesStorageKey, origin, setListCaracteristicas, setListCategory, setListDatas, setListEstados, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    const redirectToLink = useCallback(() => {
        const linkElement = document.getElementById("myLink");
        if (linkElement) {
          linkElement.click();
        }
    }, []);

    useEffect(() => {
        if(showAdvanced && (showHomeCaracteristicas || showHomeCategoria || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
        if(site?.id == 2379){
          setBuscaAvancada(showAdvanced)
        }
    }, [GetInitialFilters, setBuscaAvancada, showAdvanced, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    useEffect(() => {
      if(buscaAvancada)
        setShowAdvanced(buscaAvancada)
    }, [buscaAvancada]);

    useEffect(() => {
        const nextBounds = getBoundsByTransaction(transacaoActual?.value);
        if (!nextBounds) return;

        const nextMin = Number(nextBounds?.min) || 0;
        const nextMax = Number(nextBounds?.max) || 0;

        setPrecoMin((current) => current === nextMin ? current : nextMin);
        setPrecoMax((current) => current === nextMax ? current : nextMax);
    }, [getBoundsByTransaction, transacaoActual?.value]);

    useEffect(() => {
        if (allCitiesAux?.length === 1) {
            const onlyCity = allCitiesAux[0];
            if (citiesActual?.value !== onlyCity?.value) {
                onChangeCity(onlyCity);
            }
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
            redirectToLink();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
    }, [allCitiesAux, citiesActual?.value, onChangeCity, redirectToLink]);

  const GetOnlyCityCanoas = () => {
      const GetOnlyType = allCitiesAux.filter((e: any) => {
          return String(e.label)=="Canoas";
      })
      return GetOnlyType[0];
  };

  // allTransacao pode ter mais opções que site.transacoes: o cs2679 ganha Aluguel só na busca da home
  // (BUSCA_HOME_COM_ALUGUEL em pages/index.tsx). Nos demais tenants as duas contagens são iguais.
  const transacaoCount = Math.max(site?.transacoes?.length || 2, allTransacao?.length || 0);
  const heroBannerSrc = urlBanner
    ? site?.id == 2073 && isMobile1
      ? 'https://imob.sobressai.com.br/Banner/2073/12087.jpg'
      : urlBanner
    : '';

  return (
    <div className={`${styles.container}`}>
      <DrawerComponent
          site={site}
          activeDrawer={activeDrawer}
          setActiveDrawer={setActiveDrawer}
          favorito={favorito}
          menus={props?.menus}
      />
      {/* Banner Background */}
      <div className={styles.banner}>
        {heroBannerSrc ? (
          <Image
            src={heroBannerSrc}
            alt={`Imagem principal da imobiliária ${site?.Dados?.empresa || ''}`.trim()}
            fill
            priority
            quality={70}
            sizes="100vw"
            className={styles.bannerImage}
          />
        ) : null}
        {!heroBannerSrc && site?.url_video && site?.id != 2177 && (
          <video
            autoPlay={!videoParado}
            muted
            loop
            height="100%"
            width="100%"
            className={styles.video_render}
            poster={heroPoster}
            src={heroPoster ? (heroVideoReady ? site.url_video : undefined) : site.url_video}
            playsInline
            preload={heroPoster ? 'none' : videoParado ? 'metadata' : 'auto'}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <track kind="captions" label="Legenda" src="legenda.vtt" />
          </video>
        )}
        {/* Overlay */}
        <div className={styles.overlay} />

        {/* Animated Persona - positioned behind content */}
        {/* NÃO animar opacity: a persona (recorte de pessoa) semitransparente sobre o
            banner de fundo criava "dupla exposição" no primeiro paint. Mantemos só o
            leve slide-up de entrada — a persona fica sempre opaca (opacity 1), então
            nunca aparece sobreposta ao fundo de forma fantasmagórica. */}
        {personaSrc ? (
          <motion.div
            className={styles.persona_div}
            initial={{ y: 24 }}
            animate={{ y: 0 }}
            transition={{
              delay: 0,
              duration: 0.45,
              ease: "easeOut",
            }}
          >
            <Image
              src={personaSrc}
              alt="Persona da imobiliária"
              className={styles.persona}
              width={900}
              height={1400}
              loading="lazy"
              sizes="(max-width: 768px) 70vw, 40vw"
              quality={65}
            />
          </motion.div>
        ) : null}

        {/* Content */}
        <div className={heroTituloNoCelular ? `${styles.content} ${styles.contentTituloMobile}` : styles.content} style={site?.id == 2379 ? {display: "none"} : {}}>
          {/* Welcome Text */}
          <div className={heroTituloNoCelular ? `${styles.textContent} ${styles.textContentTituloMobile}` : styles.textContent}>
            {site?.frase_busca ?
            site?.id == '2112' ?
              <motion.h1
                className={styles.title}
                style={{ fontSize: '64px', margin: '0px' }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08, duration: 0.45, ease: "easeOut" }}
                dangerouslySetInnerHTML={{
                  __html: site?.frase_busca.toUpperCase(),
                }}
              ></motion.h1>
            :
              <motion.h1
                className={styles.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08, duration: 0.45, ease: "easeOut" }}
                dangerouslySetInnerHTML={{
                  __html:
                    site?.id === 2177
                      ? `<span style="font-weight:100;">Descubra o Melhor do </span><span style="font-weight:bold;">Litoral Catarinense</span><span style="font-weight:100;"> e da </span><span style="font-weight:bold;">Serra Gaúcha</span>.<br>
                                <span style="font-weight:100;">Imóveis exclusivos em </span><span style="font-weight:bold;">Itapema, Gramado e Canela</span><span style="font-weight:100;"> com a </span><span style="font-weight:bold;">confiança da Imobiliária Régis da Silveira</span>.`
                      : site?.frase_busca,
                }}
              ></motion.h1>
            : null}
            {site?.frase_busca_2 ?
              <motion.h2
                className={styles.subtitle}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.12, duration: 0.45, ease: "easeOut" }}
              >
                {site?.frase_busca_2}
              </motion.h2> : null}
          </div>

          {/* Search Bar */}
            <motion.div
              className={styles.searchBar}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1, duration: 0.45, ease: "easeOut" }}
            >
            <div className={`${site?.id == 2379 ? styles.column1 : styles.column}`}>
              {/* Transaction Type - only show if more than 1 */}
              {transacaoCount > 1 && (
                <div className={styles.field}>
                  <label htmlFor="home2-transacao" className={styles.visually_hidden}>Transacao</label>
                  <Select
                      inputId="home2-transacao"
                      aria-label="Transação"
                      defaultValue={allTransacao[0]?.value}
                      options={allTransacao}
                      placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value :"Transação"}
                      noOptionsMessage={() =>
                          'Processando'
                      }
                      menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                      styles={{
                      ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      })
                    }}
                      menuPlacement="auto"
                      value={transacaoActual}
                      onChange={onChangeTransacao}
                      instanceId={1}
                      isSearchable={false}
                  />
                </div>
              )}

              {/* Property Type */}
              <div className={styles.field}>
                <label htmlFor="home2-tipo-imovel" className={styles.visually_hidden}>Tipo de imovel</label>
                <Select
                    inputId="home2-tipo-imovel"
                    aria-label="Tipo de imóvel"
                    options={allTypes}
                    isMulti
                    placeholder={urlTipo ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                    closeMenuOnSelect={site?.id == "2091" ? true : false}
                    controlShouldRenderValue={false}
                    noOptionsMessage={() =>
                        'Tipo não encontrado'
                    }
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    value={typesActual}
                    onChange={onChangeTypes}
                    closeMenuOnScroll={true}
                    isSearchable
                    instanceId={2}
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                    menuPlacement="auto"
                />
              </div>

              {/* City */}
              <div className={styles.field}>
                <label htmlFor="home2-cidade" className={styles.visually_hidden}>Cidade</label>
                <Select
                  inputId="home2-cidade"
                  aria-label="Cidade"
                  options={allCitiesAux}
                  placeholder="Cidade"
                  noOptionsMessage={() =>
                      'Cidade não encontrada'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  onChange={onChangeCity}
                  value={!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual}
                  instanceId={3}
                  {...cidadesMulti.selectProps}
                  menuPlacement="auto"
                  styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                  isSearchable
                />
              </div>

              {/* District */}
              <div className={styles.field}>
                <label htmlFor="home2-bairro" className={styles.visually_hidden}>Bairro</label>
                <Select
                  inputId="home2-bairro"
                  aria-label="Bairro"
                  options={allDistrict}
                  placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                  closeMenuOnSelect={site?.id == "2091" ? true : false}
                  controlShouldRenderValue={false}
                  hideSelectedOptions={false}
                  tabSelectsValue={false}
                  noOptionsMessage={() =>
                      citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  menuPlacement="auto"
                  styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                  isMulti
                  value={districtActual}
                  onChange={onChangeDistrict}
                  isSearchable
                  instanceId={4}
                />
              </div>

              {/* Condominium */}
              {site?.exibir_empreendimento && (site?.id == 2473 || site?.id == 2274 || isSite2587 || isSite2262 || isSite1630) ?
              <div className={styles.field}>
                <Select
                  options={allCompany}
                  placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : isSite1630 ? "Empreendimentos" : "Condomínios"}
                  value={companyActual}
                  inputValue={companyInputActual}
                  noOptionsMessage={() =>
                      isSite1630
                        ? (allCompany?.length > 1 ? 'Empreendimento não encontrado' : 'Digite o nome do empreendimento')
                        : allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                  }
                  styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                  menuPlacement="auto"
                  isSearchable
                  instanceId={22}
                  onChange={onChangeCompany}
                  onInputChange={onInputChangeCompany}
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                />
              </div>: null}

              {CODIGO_NA_BARRA_SITES.includes(Number(site?.id)) ?
                <div className={styles.field}>
                  <input
                    type="text"
                    placeholder="Código"
                    value={codeActual}
                    onChange={onChangeCode}
                    className={styles.simplifiedInput}
                    style={codeInputVars}
                  />
                </div>: null}

              {/* Search Button */}
              <div className={styles.fieldCTA} style={{ alignContent: "center",minHeight: "35px"}}>
                <Link
                  prefetch={false}
                  href={renderPath()}
                  type="button"
                  id="myLink"
                  onClick={fireMetaSearch}
                  className={styles.cta}
                >
                  Encontrar imóvel
                </Link>
              </div>
            </div>
          </motion.div>

          {/* Busca Avançada text */}
          <motion.div
            className={`${site?.id == 2379 ? styles.advancedText1 : styles.advancedText}`}
            onClick={() => { trackMetaEvent(site, 'ViewContent', { content_name: 'Busca avançada', content_category: 'property_search' }); setShowAdvanced(true); }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.14, duration: 0.45, ease: "easeOut" }}
          >
            BUSCA AVANÇADA
          </motion.div>

          <CardsBusca cards={allCards} site={site} variante="escuro" />
        </div>
      </div>

      {/* Advanced Search Popup */}
      {showAdvanced && (
        <div className={styles.popupOverlay} onClick={() => setShowAdvanced(false)}>
          <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
            <div className={styles.popupHeader}>
              <span>Buscar imóveis</span>
              <button
                className={styles.popupClose}
                onClick={() => setShowAdvanced(false)}
              >
                ×
              </button>
            </div>

            <div className={styles.popupBody}>
              {/* Código */}
              <div className={styles.formItem} style={isSite2587 ? { display: 'none' } : undefined}>
                <label className={styles.formLabel}>Códigos</label>
                <input
                  type="text"
                  placeholder="1000, 2000, ..."
                  value={codeActual}
                  onChange={onChangeCode}
                  className={styles.formInput}
                />
              </div>
              {isSite2587 && site?.exibir_empreendimento ? (
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Condomínio</label>
                  <Select
                    options={allCompany}
                    className={styles.select1}
                    placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : "Condomínios"}
                    value={companyActual}
                    inputValue={companyInputActual}
                    noOptionsMessage={() =>
                        allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                    }
                    instanceId={9}
                    onChange={onChangeCompany}
                    onInputChange={onInputChangeCompany}
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
                </div>
              ) : null}

              <div className={styles.separator}>ou</div>

              {/* Transaction Type */}
              {}

                {transacaoCount > 1 && (
                  <div className={styles.formItem}>
                  <label className={styles.formLabel}>Negociação</label>
                  <Select
                      defaultValue={allTransacao[0]?.value}
                      options={allTransacao}
                      className={styles.select}
                      placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value :"Transação"}
                      noOptionsMessage={() =>
                          'Processando'
                      }
                      menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                      styles={{
                        ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                        menuPortal: (base: any) => ({          // << z-index garantido
                          ...base,
                          zIndex: 10000,
                        }),
                      }}
                      menuPlacement="auto"
                      value={transacaoActual}
                      onChange={onChangeTransacao}
                      instanceId={1}
                      isSearchable={false}
                  />
                </div>
              )}

              {/* Property Type */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Tipos de Imóveis</label>
                <Select
                  isMulti
                  placeholder={typesActual?.length ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                  options={allTypes}
                  noOptionsMessage={() =>
                      'Tipo não encontrado'
                  }
                  controlShouldRenderValue={false}
                  closeMenuOnSelect={site?.id == "2091" ? true : false}
                  hideSelectedOptions={false}
                  tabSelectsValue={false}
                  value={typesActual}
                  onChange={onChangeTypes}
                  closeMenuOnScroll={true}
                  instanceId={14}
                  isSearchable
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* City */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Cidade</label>
                <Select
                  options={allCitiesAux}
                  placeholder="Cidade"
                  noOptionsMessage={() =>
                      'Cidade não encontrada'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  onChange={onChangeCity}
                  value={!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual}
                  instanceId={41}
                  {...cidadesMulti.selectProps}
                  menuPlacement="auto"
                  isSearchable
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* District */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Bairro</label>
                <Select
                  options={allDistrict}
                  placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                  closeMenuOnSelect={site?.id == "2091" ? true : false}
                  controlShouldRenderValue={false}
                  hideSelectedOptions={false}
                  tabSelectsValue={false}
                  noOptionsMessage={() =>
                      citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                  }
                  isMulti
                  value={districtActual}
                  onChange={onChangeDistrict}
                  isSearchable
                  instanceId={40}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* Category */}
              {showHomeCategoria && listCategory?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Categoria</label>
                  <Select
                    options={listCategory}
                    className={styles.select}
                    placeholder="Categoria"
                    noOptionsMessage={() =>
                        'Categoria não encontrada'
                    }
                    onChange={onChangeCategory}
                    value={categoryActual}
                    instanceId={3}
                    isSearchable
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
              </div>}

              {/* Características */}
              {showHomeCaracteristicas && listCaracteristicas?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Mais características</label>
                  <Select
                    options={listCaracteristicas}
                    className={styles.select}
                    isMulti
                    placeholder={urlCaract ? caractActual?.length + " Selecionada (s)" : "Características"}
                    noOptionsMessage={() =>
                        'Característica não encontrada'
                    }
                    closeMenuOnSelect={false}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    onChange={onChangeCaracteristicas}
                    value={caractActual}
                    closeMenuOnScroll={false}
                    instanceId={12}
                    isSearchable
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
              </div>}

              {site?.mostrar_data_entrega && listDatas?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Data Entrega</label>
                  <Select
                    options={listDatas}
                    className={styles.select}
                    isMulti
                    placeholder={urlDatas ? dataEntregaActual?.length + " Selecionada (s)" : "Datas de entrega"}
                    noOptionsMessage={() =>
                        'Data de entrega não encontrada'
                    }
                    closeMenuOnSelect={false}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    onChange={onChangeDataEntrega}
                    value={dataEntregaActual}
                    closeMenuOnScroll={false}
                    instanceId={12}
                    isSearchable
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
                </div>
              }

              {/* Condominium */}
              {site?.exibir_empreendimento && !isSite2587 && !isSite2262 &&
              <div className={styles.formItem}>
                <label className={styles.formLabel}>{isSite1630 ? "Empreendimento" : "Condomínio"}</label>
                <Select
                  options={allCompany}
                  className={styles.select1}
                  placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : isSite1630 ? "Empreendimentos" : "Condomínios"}
                  value={companyActual}
                  inputValue={companyInputActual}
                  noOptionsMessage={() =>
                      isSite1630
                        ? (allCompany?.length > 1 ? 'Empreendimento não encontrado' : 'Digite o nome do empreendimento')
                        : allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                  }
                  instanceId={9}
                  onChange={onChangeCompany}
                  onInputChange={onInputChangeCompany}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>}
              {isSite2587 ? (
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Códigos</label>
                  <input
                    type="text"
                    placeholder="1000, 2000, ..."
                    value={codeActual}
                    onChange={onChangeCode}
                    className={styles.formInput}
                  />
                </div>
              ) : null}

              {/* Price Range */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Faixa de preço</label>
                <div className={styles.priceInputs}>
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="R$ de..."
                    value={precoMin === 0 ? '' : precoMin}      // mostra vazio quando for 0
                    onChange={(e) => {
                      const limpo = onlyDigits(e.target.value); // "12345"
                      setPrecoMin(Number(limpo));               // agora é number
                    }}
                    className={styles.formInput}
                  />
                  <input
                    min={0}
                    type="text"
                    inputMode="numeric"
                    placeholder={"R$ até..."}
                    value={precoMax === 0 ? '' : precoMax}      // mostra vazio quando for 0
                    onChange={(e) => {
                      const limpo = onlyDigits(e.target.value); // "12345"
                      setPrecoMax(Number(limpo));               // agora é number
                    }}
                    className={styles.formInput}
                  />
                </div>
              </div>

              {showHomeDormitorios && (
                <>
                  {/* Quartos */}
                  <div className={styles.formItem}>
                    <label className={styles.formLabel}>Quartos</label>
                    <div className={styles.checkNumbers}>
                      {['1', '2', '3', '4', '5+'].map(num => (
                        <label key={num} className={styles.checkLabel}>
                          <input
                            type="checkbox"
                            checked={dormitoriosActual == num}
                            onChange={() => onChangeDormitorios(num)}
                          />
                          <span>{num}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Suites */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Suítes</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={suitesActual == num}
                        onChange={() => onChangeSuites(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Banheiros */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Banheiros</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={banheirosActual == num}
                        onChange={() => onChangeBanheiros(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Vagas */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Vagas</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={vagasActual == num}
                        onChange={() => onChangeVagas(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className={styles.popupFooter}>
              <button
                type="button"
                className={styles.clearBtn}
                onClick={clearFilters}
              >
                <span>Limpar filtros</span>
              </button>
              <Link
                prefetch={false}
                href={renderPath()}
                type="button"
                onClick={fireMetaSearch}
                className={styles.searchBtn}
              >
                <span>Filtrar</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomePieces2;
